import React from 'react';

interface PropsType {
  children: React.ReactNode;
}

const AppInitWrapper: React.FC<PropsType> = ({ children }) => {
  return <>{children}</>;
};

export default AppInitWrapper;
